import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import axios from 'src/utils/axios';

interface Redirect301GuardProps {
  children?: ReactNode;
}

const Redirect301Guard: FC<Redirect301GuardProps> = ({ children }) => {
  const [redirectUrls, setRedirectUrls] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchRedirects = async () => {
      try {
        const configRes = await axios.get('api/website/redirecturl/config');

        if (configRes.data.status) {
          const redirectToken = localStorage.getItem('redirectToken');

          if (redirectToken !== configRes.data.data) {
            const urlRes = await axios.get(
              'api/website/redirecturl/get?page=1&size=300'
            );

            if (urlRes.data.status) {
              localStorage.setItem(
                'redirecturls',
                JSON.stringify(urlRes.data.data)
              );
              localStorage.setItem(
                'redirectToken',
                configRes.data.data
              );
              setRedirectUrls(urlRes.data.data);
            }
          } else {
            const stored = localStorage.getItem('redirecturls');
            if (stored) {
              setRedirectUrls(JSON.parse(stored));
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchRedirects();
  }, []);

  if (loading) return null;

  const result = redirectUrls.find(
    (item) => item.old_url === location.pathname
  );

  if (result?.new_url) {
    return <Redirect to={result.new_url} />;
  }

  return <>{children}</>;
};

export default Redirect301Guard;
